module.exports = __webpack_public_path__ + "img/logo3.f571a75b.png";